import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import styles from "./EmployeeDetail.module.css";
import { testUrl } from "../home/BaseData";

const EmployeeDetail = () => {
    const { id } = useParams();
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [employee, setEmployee] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(null);

    // Static tabs matching backend TYPE_CHOICES
    const tabOptions = [
        { key: 'kitoblar', label_uz: 'Kitoblar', label_en: 'Books', label_ru: 'Книги' },
        { key: 'maqolalar', label_uz: 'Maqolalar', label_en: 'Articles', label_ru: 'Статьи' },
        { key: 'avtoreferat', label_uz: 'Avtoreferat (PhD, DSc)', label_en: 'Abstract (PhD, DSc)', label_ru: 'Автореферат (PhD, DSc)' },
        { key: 'loyihalar', label_uz: 'Loyihalar', label_en: 'Projects', label_ru: 'Проекты' },
        { key: 'sertifikatlar', label_uz: 'Sertifikatlar', label_en: 'Certificates', label_ru: 'Сертификаты' },
    ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${testUrl}/api/employees/${id}/`);
                setEmployee(response.data);
            } catch (error) {
                console.error("Error fetching employee details:", error);
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchData();
        }
    }, [id, i18n.language]);

    if (loading) return <div className={styles.container}>{t("loading")}</div>;
    if (!employee) return <div className={styles.container}>Xodim topilmadi</div>;

    const currentLang = i18n.language; // 'uz', 'ru', 'en'
    const name = employee[`name_${currentLang}`] || employee.name_uz;
    const about = employee[`about_${currentLang}`] || employee.about_uz;
    const email = employee.email;

    // Filter files based on selected tab type
    const details = employee.details || [];
    const filteredFiles = activeTab ? details.filter(detail => detail.type === activeTab) : [];

    return (
        <div className={styles.container}>
            <div className={styles.profileCard}>
                <div className={styles.imageWrapper}>
                    <img
                        src={employee.image || "/media/employees/avatar.png"}
                        alt={name}
                        className={styles.image}
                    />
                </div>
                <div className={styles.profileInfo}>
                    <h1 className={styles.name}>{name}</h1>

                    <div className={styles.detailRow}>
                        <span className={styles.label}>{t("email")}:</span>
                        <a href={`mailto:${email}`} className={styles.email}>{email}</a>
                    </div>

                    {employee[`work_experience_${currentLang}`] && (
                        <div className={styles.detailRow}>
                            <span className={styles.label}>{t("ish_staj") || "Ish tajribasi"}:</span>
                            <span className={styles.value}>{employee[`work_experience_${currentLang}`]}</span>
                        </div>
                    )}
                </div>
            </div>

            <div className={styles.aboutSection}>
                <div dangerouslySetInnerHTML={{ __html: about }} />
            </div>

            <div className={styles.tabsContainer}>
                {tabOptions.map((tab) => (
                    <button
                        key={tab.key}
                        className={`${styles.tabButton} ${activeTab === tab.key ? styles.active : ''}`}
                        onClick={() => setActiveTab(activeTab === tab.key ? null : tab.key)}
                    >
                        {tab[`label_${currentLang}`] || tab.label_uz}
                    </button>
                ))}
            </div>

            {activeTab && (
                <div className={styles.contentSection}>
                    {filteredFiles.length > 0 ? (
                        <div className={styles.fileList}>
                            {filteredFiles.map((file) => (
                                <div key={file.id} className={styles.fileItem}>
                                    <span className={styles.fileTitle}>{file.title}</span>
                                    <a
                                        href={file.file}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={styles.downloadButton}
                                        download
                                    >
                                        {t("download") || "Yuklab olish"}
                                    </a>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p style={{ textAlign: "center", color: "#666" }}>
                            {t("noFilesAvailable") || "Hozircha hech qanday fayl mavjud emas"}
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

export default EmployeeDetail;
